import React from "react";
import { Instagram } from "lucide-react";
import { Link } from "react-router-dom";
import { WebJestersSiteLink } from "./WebJestersSiteLink";

/**
 * Small persistent attribution footer. Shows on every authenticated page via
 * Layout.jsx. Non-intrusive, dark-palette, keyboard-accessible.
 */
export default function PoweredByFooter() {
    const year = new Date().getFullYear();
    return (
        <footer
            data-testid="powered-by-footer"
            className="flex flex-wrap shrink-0 border-t border-zinc-900/80 bg-[#0a0a0a] px-6 py-4 mb-16 md:mb-0 items-center justify-between gap-4 text-[11.5px] text-zinc-500"
        >
            <span data-testid="powered-by-text">
                Powered by{" "}
                <WebJestersSiteLink testid="footer-webjesters-link" className="text-zinc-300 font-medium" />
                <span className="hidden sm:inline"> · © {year}</span>
                <span className="hidden lg:inline text-zinc-600"> · </span>
                <Link to="/privacy" data-testid="footer-privacy-link" className="hidden lg:inline hover:text-zinc-200 transition-colors">Privacy</Link>
                <span className="hidden lg:inline text-zinc-600"> · </span>
                <Link to="/terms" data-testid="footer-terms-link" className="hidden lg:inline hover:text-zinc-200 transition-colors">Terms</Link>
            </span>
            <a
                href="https://www.instagram.com/webjesters"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="powered-by-instagram-link"
                aria-label="WebJesters on Instagram"
                className="inline-flex items-center gap-1.5 text-zinc-500 hover:text-zinc-200 transition-colors"
            >
                <Instagram className="h-3.5 w-3.5 stroke-[1.75]" />
                <span className="hidden sm:inline">@webjesters</span>
            </a>
        </footer>
    );
}
